import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./slices";
import { setApiDispatch } from "./helpers/api_helper";

const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== "production",
});

setApiDispatch(store.dispatch);

export type AppDispatch = typeof store.dispatch;
export default store;
